export function hashSeed(seed: number, q: number, r: number, s: number): number {
    let h = seed >>> 0;
    h ^= Math.imul(q | 0, 73856093);
    h ^= Math.imul(r | 0, 19349663);
    h ^= Math.imul(s | 0, 83492791);
    return h >>> 0;
}

export function hashStringSeed(value: string): number {
    let h = 2166136261;
    for (let i = 0; i < value.length; i += 1) {
        h ^= value.charCodeAt(i);
        h = Math.imul(h, 16777619);
    }
    return h >>> 0;
}

export function mulberry32(seed: number): () => number {
    let t = seed >>> 0;
    return () => {
        t += 0x6d2b79f5;
        let x = Math.imul(t ^ (t >>> 15), 1 | t);
        x ^= x + Math.imul(x ^ (x >>> 7), 61 | x);
        return ((x ^ (x >>> 14)) >>> 0) / 4294967296;
    };
}
